/* ============================================================
   Anime Alley, Buylist landing pages
   Reveal-on-scroll, FAQ accordion, mail/in-store steps toggle.
   No dependencies; the landing layout loads only this.
   ============================================================ */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- reveal on scroll (transform-only; content is never hidden) ---- */
    var reveals = [].slice.call(document.querySelectorAll('.reveal'));
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      reveals.forEach(function (el) { io.observe(el); });
      // failsafe: never leave anything stuck off-screen
      setTimeout(function () { reveals.forEach(function (el) { el.classList.add('in'); }); }, 2500);
    }

    /* ---- FAQ accordion ---- */
    document.querySelectorAll('.qa__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qa = btn.closest('.qa');
        if (!qa) return;
        var isOpen = qa.getAttribute('data-open') === '1';
        document.querySelectorAll('.qa[data-open="1"]').forEach(function (o) {
          o.setAttribute('data-open', '0');
          var b = o.querySelector('.qa__q'); if (b) b.setAttribute('aria-expanded', 'false');
        });
        qa.setAttribute('data-open', isOpen ? '0' : '1');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    /* ---- how-it-works: mail-in / in-store toggle ---- */
    var seg = document.querySelector('[data-steps-seg]');
    if (seg) {
      seg.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-mode]');
        if (!b) return;
        var mode = b.getAttribute('data-mode');
        seg.querySelectorAll('button[data-mode]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        document.querySelectorAll('[data-steps]').forEach(function (g) {
          if (g.getAttribute('data-steps') === mode) g.removeAttribute('hidden');
          else g.setAttribute('hidden', '');
        });
      });
    }
  });
})();
